// removed by extract-text-webpack-plugin
module.exports = {"tab":"_1ob4fdycExRTUiPnXDRq8R","active":"_2Db03QLl5Nmn0O3oFqMrNx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/Tab/Tab.scss
// module id = 1335
// module chunks = 1